import { Record } from 'immutable';

export default Record({
    asin: null,
    createdAt: null,
    fetchedAt: null,
    fetches: 0,
    found: 0,
    reviewDate: null,
    reviewerId: null,
    reviewerName: '',
    reviewId: null,
    reviewRemovedDate: null,
    stars: null,
    summary: '',
    title: '',
    updatedAt: null
});
